module.exports = __webpack_public_path__ + "img/dots_lub_2.47fc773c.png";